export const SET_PORTABILITY = 'SET_PORTABILITY';
export const SET_AVAILABLE_NUMBERS = 'SET_AVAILABLE_NUMBERS';
export const SET_ADDICIONAL_NUMBERS = 'SET_ADDICIONAL_NUMBERS';
export const UPDATE_ADDITIONAL_PLAN_VALUE = 'UPDATE_ADDITIONAL_PLAN_VALUE';
export const SET_CHOSEN_NUMBER = 'SET_CHOSEN_NUMBER';
export const SET_PAYMENT_ENTITY = 'SET_PAYMENT_ENTITY';
export const SET_PAYMENT_REF = 'SET_PAYMENT_REF';
export const SET_PAYMENT_TOTAL = 'SET_PAYMENT_TOTAL';
export const SET_LAST_SESSION_ID = 'SET_LAST_SESSION_ID';
export const UPDATE_PORTABILITY_INFO_VALUE = 'UPDATE_PORTABILITY_INFO_VALUE';

export default {
  SET_PORTABILITY,
  SET_ADDICIONAL_NUMBERS,
  UPDATE_ADDITIONAL_PLAN_VALUE,
  UPDATE_PORTABILITY_INFO_VALUE,
  SET_AVAILABLE_NUMBERS,
  SET_CHOSEN_NUMBER,
  SET_PAYMENT_ENTITY,
  SET_PAYMENT_REF,
  SET_PAYMENT_TOTAL,
  SET_LAST_SESSION_ID
};



// WEBPACK FOOTER //
// ./src/store/modules/movel/types.js